import { ImageBuilder } from '@jcom/common-components';
import React, { useEffect } from 'react';

export const ImageRender = ({
	baseColor,
	trimColor,
	imageList,
	tipImage,
	zoneName,
	zoneArea,
	numberOfOccurance
}) => {
	useEffect(() => {
		setTimeout(() => {
			let occurance = [1];
			if(numberOfOccurance) {
				occurance = Array.from({length: numberOfOccurance}, (x, i) => i+1)
			}
			occurance.map((id)=>{
				ImageBuilder.addColor({
					pathId: 'BaseColor',
					colorCode: baseColor,
					id,
				});

				ImageBuilder.addColor({
					pathId: 'TrimColor',
					colorCode: trimColor,
					id,
				});

				tipImage
					? ImageBuilder.addTip({
							imgPath: `${process.env.REACT_APP_JOSTENS_CDN_HOST}${tipImage}`,
							imgHeight: '500px',
							imgWidth: '500px',
							zone: 'tip',
							id,
						})
					: ImageBuilder.addTip({ imgPath: '', zone: 'tip', id });

				ImageBuilder.ZoneNameComponent({ zoneNames: zoneName, id });

				ImageBuilder.ZoneHighLightComponent({ zoneNames: zoneArea, id});

				if (imageList && imageList.length > 0) {
					imageList.forEach((imgData) => {
						ImageBuilder.addImage({
							imgPath: imgData.imgPath,
							x: 72 * imgData.x,
							y: 72 * imgData.y,
							imgWidth: 72 * imgData.imgWidth + 'px',
							imgHeight: 72 * imgData.imgHeight + 'px',
							zone: imgData.zone,
							id,
							isPatch: imgData.isPatch
						});
					});
				}
			});
		}, 0);
	});
	return <></>;
};
